import { Recurso } from "lib.common/dist/CleanArch";
import { ErrExterno } from "lib.common/dist/errorHandler";

interface BasicError {
    message: string,
    stack?: string,
}

export function gqlErrorMapperRecurso<T>(error: BasicError | undefined): Recurso<T> | undefined {
    if (error) {
        return Recurso.fromError<T>(
            new ErrExterno(
                new Error(error.message),
                undefined,
                process.env.REACT_APP_DS_ENV !== 'PROD' ? error.stack : undefined
            )
        );
    }
    return undefined;
}

export function gqlErrorsMapperRecurso<T>(errors: readonly BasicError[] | undefined): Recurso<T> {
    if (errors) {
        const messages = errors.map(value => value.message);
        const stacks = errors.map(value => value.stack);
        return Recurso.fromError<T>(
            new ErrExterno(
                new Error(messages.toString()),
                undefined,
                process.env.REACT_APP_DS_ENV !== 'PROD' ? stacks : undefined
            )
        );
    }
    return undefined;
}

